/* eslint-disable react/prop-types */
/* eslint-disable react-native/no-inline-styles */
/*
Author: Gilang Romadhanu Tartila
*/

import React, { useState } from 'react';
import { useDispatch } from 'react-redux';
import { View, StyleSheet, TouchableOpacity, ScrollView } from 'react-native';

import ModalFull from '@components/modal/ModalFull';
import SociollaText from '@components/sociolla/SociollaText';
import Photo from '@components/global/Photo';
import ProgressChart from '@components/chart/ProgressChart';
import IncentiveTracker from '@/screens/home/components/snippets/IncentiveTracker';

import Colors from '@global/colors';
import { isWeb, fullHeight } from '@global/screens';
import { showPopup } from '@/store/modal';

function SalesMember(props) {
  const { style = {} } = props;
  const dispatch = useDispatch();
  const [showTracker, setShowTracker] = useState(false);
  return (
    <>
      <View
        style={[
          styles.teamMemberItem,
          !isWeb ? styles.teamMemberItemMobile : {},
          style,
        ]}>
        <View style={styles.teamMemberUser}>
          <Photo
            image={''}
            width={25}
            height={25}
            style={styles.teamMemberPhoto}
          />
          <SociollaText style={styles.teamMemberText}>
            Ogasawara Katsumi
          </SociollaText>
        </View>
        <View style={styles.teamMemberContent}>
          <View style={styles.memberCount}>
            <View style={styles.memberCountWrapper}>
              <SociollaText type="medium" style={styles.memberTitle}>
                Sales Achivement
              </SociollaText>
              <SociollaText
                type="bold"
                style={[styles.memberTotal, styles.textBlue]}>
                78%
              </SociollaText>
            </View>
            <View style={styles.memberCountWrapper}>
              <SociollaText type="medium" style={styles.memberTitle}>
                National Ranking
              </SociollaText>
              <View style={styles.memberTotalGroup}>
                <SociollaText
                  type="bold"
                  style={[styles.memberTotal, styles.textYellow]}>
                  28
                </SociollaText>
                <SociollaText style={styles.memberTotalDesc}>
                  of 280
                </SociollaText>
              </View>
            </View>
          </View>
          <View style={styles.memberCount}>
            <View style={styles.memberCountWrapper}>
              <SociollaText type="medium" style={styles.memberTitle}>
                Activities Planned
              </SociollaText>
              <View>
                <SociollaText style={styles.memberTotalMiniTitle}>
                  Planned
                </SociollaText>
                <SociollaText
                  type="bold"
                  style={[styles.memberTotal, styles.textGrey]}>
                  12
                </SociollaText>
              </View>
            </View>
            <View style={styles.memberCountWrapper}>
              <SociollaText
                type="medium"
                style={[styles.memberTitle, { color: Colors.white }]}>
                Activities Planned
              </SociollaText>
              <View>
                <SociollaText style={styles.memberTotalMiniTitle}>
                  Done
                </SociollaText>
                <SociollaText
                  type="bold"
                  style={[styles.memberTotal, styles.textBlue]}>
                  65
                </SociollaText>
              </View>
            </View>
            <View style={styles.teamMemberContent}>
              <ProgressChart count={70} containerStyle={styles.progressTop} />
            </View>
          </View>
          <View
            style={[
              styles.memberCount,
              { borderBottomColor: Colors.transparent },
            ]}>
            <View style={styles.memberCountWrapper}>
              <SociollaText type="medium" style={styles.memberTitle}>
                Total DOORS
              </SociollaText>
              <SociollaText
                type="bold"
                style={[styles.memberTotal, styles.textBlueSky]}>
                7
              </SociollaText>
            </View>
            <View style={styles.memberCountWrapper}>
              <SociollaText type="medium" style={styles.memberTitle}>
                New Acquired Cust.
              </SociollaText>
              <SociollaText
                type="bold"
                style={[styles.memberTotal, styles.textYellow]}>
                7
              </SociollaText>
            </View>
            <View style={styles.memberCountWrapper}>
              <SociollaText type="medium" style={styles.memberTitle}>
                Total Cust. Visit
              </SociollaText>
              <View style={styles.memberTotalGroup}>
                <SociollaText
                  type="bold"
                  style={[styles.memberTotal, styles.textBlue]}>
                  2
                </SociollaText>
                <TouchableOpacity
                  activeOpacity={0.8}
                  onPress={() => {
                    dispatch(
                      showPopup({ name: 'visitTeamDetail', value: true }),
                    );
                  }}>
                  <SociollaText
                    style={[styles.memberTotalDesc, styles.textBlue]}>
                    see detail
                  </SociollaText>
                </TouchableOpacity>
              </View>
            </View>
            <View style={styles.memberCountWrapper}>
              <SociollaText type="medium" style={styles.memberTitle}>
                AR Paid
              </SociollaText>
              <SociollaText
                type="bold"
                style={[styles.memberTotal, styles.textBlueSky]}>
                48%
              </SociollaText>
            </View>
          </View>
          <View
            style={[
              styles.teamMember,
              styles.memberTotalGroup,
              styles.memberTrack,
            ]}>
            <SociollaText
              type="medium"
              style={[styles.memberTitle, styles.mBottomZero]}>
              Incentive
            </SociollaText>
            <TouchableOpacity
              activeOpacity={0.8}
              style={styles.trackButton}
              onPress={() => setShowTracker(true)}>
              <SociollaText type="medium">Track</SociollaText>
            </TouchableOpacity>
          </View>
        </View>
      </View>
      <ModalFull
        show={showTracker}
        title="Incentive Tracker"
        width={isWeb ? 650 : '100%'}
        back={!isWeb}
        onClose={() => setShowTracker(false)}>
        <ScrollView
          style={[
            { width: '100%', maxHeight: fullHeight - (isWeb ? 110 : 55) },
            !isWeb ? { padding: 15, backgroundColor: Colors.grey0 } : {},
          ]}>
          <View style={styles.teamMemberUser}>
            <Photo
              image={''}
              width={25}
              height={25}
              style={styles.teamMemberPhoto}
            />
            <SociollaText style={styles.teamMemberText}>
              Ogasawara Katsumi
            </SociollaText>
          </View>
          <View style={styles.incentiveWrapper}>
            <IncentiveTracker {...props} />
          </View>
        </ScrollView>
      </ModalFull>
    </>
  );
}

const styles = StyleSheet.create({
  incentiveWrapper: {
    width: '100%',
    padding: 15,
    backgroundColor: Colors.white,
  },
  teamMemberItem: {
    width: '31%',
    backgroundColor: Colors.white,
    borderRadius: 10,
    marginBottom: 25,
    overflow: 'hidden',
  },
  teamMemberItemMobile: {
    width: '100%',
  },
  teamMemberUser: {
    width: '100%',
    padding: 15,
    borderBottomColor: Colors.grey0,
    borderBottomWidth: 1,
    flexDirection: 'row',
    alignItems: 'center',
    backgroundColor: Colors.white,
  },
  teamMemberPhoto: { marginRight: 10 },
  teamMemberText: { fontSize: 13 },
  teamMemberContent: { width: '100%' },
  memberCount: {
    width: '100%',
    flexDirection: 'row',
    flexWrap: 'wrap',
    padding: 15,
    borderBottomColor: Colors.grey0,
    borderBottomWidth: 1,
  },
  memberCountWrapper: { width: '50%', marginBottom: 10 },
  memberTitle: { fontSize: 13, marginBottom: 10 },
  memberTotal: { fontSize: 26 },
  memberTotalDesc: { fontSize: 12, color: Colors.grey1, marginLeft: 10 },
  memberTotalMiniTitle: { fontSize: 12, color: Colors.grey1, marginBottom: 5 },
  memberTotalGroup: { flexDirection: 'row', alignItems: 'center' },
  memberTrack: {
    paddingVertical: 10,
    paddingHorizontal: 15,
    justifyContent: 'space-between',
    marginBottom: 10,
  },
  trackButton: {
    width: 150,
    textAlign: 'center',
    fontSize: 13,
    borderRadius: 5,
    borderColor: Colors.grey0,
    borderWidth: 1,
    paddingVertical: 6,
    paddingHorizontal: 15,
  },
  textBlue: { color: Colors.blue0 },
  textBlueSky: { color: Colors.blue4 },
  textYellow: { color: Colors.yellow0 },
  textGrey: { color: Colors.grey1 },
  progressTop: { paddingBottom: 5 },
  mBottomZero: { marginBottom: 0 },
});

export default React.memo(SalesMember, (prev, next) => prev == next);
